import getUserProfile from "./getUserProfile";

const exports = {
    getUserProfile
};

export default exports;